<app-dialog-header title="Select Priority Codes" (closeClicked)="onCancelClick()">
</app-dialog-header>

<mat-dialog-content>
  <mat-selection-list #prioritySelection [multiple]="true">
    @for (p of priorities; track p) {
    <mat-list-option [value]="p" [selected]="isSelected(p)">
      {{ p.code }} - {{ p.description }}
    </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>